import { Link } from "react-router-dom";
import { LOGO_SBG } from "@/lib/logos";

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-auto border-t border-sbg-raspberry/10 bg-sbg-burgundy px-5 py-10 sm:py-12"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-7 text-center sm:flex-row sm:justify-between sm:gap-6 sm:text-left">
        <Link to="/" data-testid="footer-logo-link" className="inline-flex items-center gap-3">
          <img src={LOGO_SBG} alt="Southern Black Girls & Women's Consortium" className="h-10 w-auto sm:h-11" />
          <span className="font-display text-base font-black tracking-tight text-white sm:text-lg">
            Southern Black Girls &amp; Women's Consortium
          </span>
        </Link>

        <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
          <Link
            to="/"
            data-testid="footer-toolkits-link"
            className="text-sm font-semibold text-sbg-blush transition-colors hover:text-sbg-turquoise"
          >
            Toolkits
          </Link>
          <a
            href="https://southernblackgirls.org"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-homepage-link"
            className="text-sm font-semibold text-sbg-blush transition-colors hover:text-sbg-turquoise"
          >
            SBG Homepage
          </a>
          <a
            href="https://southernblackgirls.org/privacy-policy/"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-privacy-link"
            className="text-sm font-semibold text-sbg-blush transition-colors hover:text-sbg-turquoise"
          >
            Privacy Policy
          </a>
        </nav>
      </div>

      <p className="mx-auto mt-8 max-w-6xl text-center text-xs text-sbg-blush/70 sm:text-left">
        Copyright © 2026 Southern Black Girls and Women's Consortium.
      </p>
    </footer>
  );
}
